export const USER_LOGIN = 'USER_LOGIN';
export const USER_SIGNUP = 'USER_SIGNUP';

export const USER_LOGOUT = 'USER_LOGOUT';
export const CLEAR_AUTH = 'CLEAR_AUTH';

export const REMEMBER_ME = 'REMEMBER_ME';
